import script from "./LadyOfTheLake.vue?vue&type=script&setup=true&lang=ts"
export * from "./LadyOfTheLake.vue?vue&type=script&setup=true&lang=ts"

import "./LadyOfTheLake.vue?vue&type=style&index=0&id=c1ed2c38&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1ed2c38"]])

export default __exports__